/* eslint-disable no-else-return */

import { ButtonBase } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
// biome-ignore lint/suspicious/noShadowRestrictedNames: TODO
import { CheckCircle, Close, Error, Info, Warning } from '@material-ui/icons'
import cn from 'classnames'
import React from 'react'

const styles = theme => ({
  alert: {
    display: 'inline-flex',
    alignItems: 'stretch',
    position: 'relative',
    padding: '16px 32px 16px 4px',
    minHeight: '100px',
    border: theme.borders.default,
    borderRadius: '2px 0 0 2px',
    '&.success': {
      '& $border': {
        backgroundColor: theme.colors.green,
      },
      '& $icon': {
        color: theme.colors.green,
      },
    },
    '&.error': {
      '& $border': {
        backgroundColor: theme.status.errorColor,
      },
      '& $icon': {
        color: theme.status.errorColor,
      },
    },
    '&.warning': {
      '& $border': {
        backgroundColor: theme.colors.orange,
      },
      '& $icon': {
        color: theme.colors.orange,
      },
    },
    '&.info': {
      '& $border': {
        backgroundColor: theme.status.infoColor,
      },
      '& $icon': {
        color: theme.status.infoColor,
      },
    },
    '&.sm': {
      width: '460px',
    },
    '&.md': {
      width: '640px',
    },
    '&.lg': {
      minWidth: '800px',
      maxWidth: '1080px',
    },
    '&.fullWidth': {
      width: '100%',
    },
    '@media (max-width: 600px)': {
      width: '100% !important',
      minWidth: 'auto !important',
    },
  },
  border: {
    position: 'absolute',
    top: -1,
    bottom: -1,
    left: -1,
    width: '4px',
    borderRadius: '2px 0 0 2px',
  },
  icon: {
    padding: '0 16px',
  },
  text: {
    flexGrow: 1,
  },
  title: {
    margin: '2px 0 10px 0',
    fontSize: theme.typography.fontSizeBase,
    fontWeight: theme.typography.fontWeightBolder,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
  },
  message: {
    margin: 0,
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  dismiss: {
    position: 'absolute',
    borderRadius: theme.borders.borderRadius,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    top: 8,
    right: 8,
  },
})

const GetIcon = variant => {
  if (variant === 'success') {
    return <CheckCircle />
  } else if (variant === 'error') {
    return <Error />
  } else if (variant === 'warning') {
    return <Warning />
  }
  return <Info />
}

const AlertPage = ({ classes, className, fullWidth, handleDismiss, message, show, size, title, variant }) => (
  <React.Fragment>
    {show && (
      <div className={cn(classes.alert, className, size, variant, { fullWidth })} role="alert">
        <div className={cn(classes.border)} />
        <div className={cn(classes.icon)}>{GetIcon(variant)}</div>
        <div className={classes.text}>
          <h4 className={classes.title}>{title}</h4>
          <p className={classes.message}>{message}</p>
        </div>
        {handleDismiss && (
          <ButtonBase aria-label="Dismiss" className={classes.dismiss} onClick={handleDismiss}>
            <Close />
          </ButtonBase>
        )}
      </div>
    )}
  </React.Fragment>
)

AlertPage.defaultProps = {
  fullWidth: false,
  show: false,
  size: 'sm',
}

const AlertPageComponent = withStyles(styles)(AlertPage)
AlertPageComponent.displayName = 'AlertPage'
export default AlertPageComponent
